/* eslint-disable */

<template>
    <v-card>
        <v-card-text>
            <v-stepper v-model="pwdChange" vertical>
                    <v-stepper-step step="1" :complete="pwdChange > 1">Inserisci l'email</v-stepper-step>
                    <v-stepper-content step="1">
                        <v-form class="ma-2"  v-model="emailValid">
                        <v-text-field dense outlined
                            label="Inserisci la mail di cui modificare la password*"
                            id="id"
                            v-model="email"
                            required
                            :rules="[rules.mandatory, rules.emailRules]"
                        ></v-text-field>
                        </v-form>
                        <v-btn color="primary" text :disabled="$store.state.offline || !emailValid" @click="nextStep">Continua</v-btn>
                        <v-btn text @click="close" >Annulla</v-btn>
                    </v-stepper-content>
                    <v-stepper-step step="2" :complete="pwdChange > 2">Inserisci la nuova password</v-stepper-step>
                    <v-stepper-content step="2">
                        <v-form class="ma-2" v-model="valid">
                            <v-text-field dense outlined
                                label="Inserisci la nuova password*"
                                id="id"
                                v-model="pwd"
                                required
                                :rules="[rules.nameRules(pwd, 8), rules.mandatory]"
                            ></v-text-field>
                            <v-text-field dense outlined
                                label="Conferma la password*"
                                id="id"
                                v-model="pwdconfirm"
                                required
                                :rules="[rules.nameRules(pwdconfirm, 8), rules.mandatory]"
                            ></v-text-field>
                        </v-form>
                        <v-btn color="success" text :disabled="$store.state.offline || (!valid && !checkPwds)" @click="savePassword">Conferma</v-btn>
                        <v-btn color="primary" text @click="close">Annulla</v-btn>
                    </v-stepper-content>
                </v-stepper>
                <p class="error--text">{{errorMessage}}</p>
        </v-card-text>
    </v-card>
</template>

<script>
import {f_rules} from '../utils/commonUtils'

export default {
    data() {
        return {
            pwd: null,
            pwdconfirm: null,
            valid: false,
            emailValid: false,
            rules: f_rules,
            pwdChange: 1,
            email: null,
            errorMessage: null,
            user_id: null
        }
    },
    computed:{
        checkPwds(){
            if(this.pwdChange == 2){
                if(this.pwd === this.pwdconfirm) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        }
    },
    methods: {
        nextStep(){
            this.axios.get("/mastercal/users/recovery/" + this.email).then(
                res => {
                    console.log("DEBUG: risultato ricerca per mail", res)
                    if(res.data){
                        this.pwdChange = 2
                        this.user_id = res.data  // check fastapi
                    } else {
                        this.errorMessage = "Utente non trovato"
                    }
                }
            ).catch(error => {
                console.log("error status", error);
                this.errorMessage = "errore di connessione al server - riprovare. Se il problema persiste contattare l'amministratore"
            });
        },
        savePassword(){
            this.axios.put("/mastercal/users/changePassword/" + this.user_id + "?password="+ this.pwd).then(
                res => {
                    console.log("DEBUG: result of change pw", res)
                    if(res.status === 200){
                        this.$router.push({name: 'login'})
                    } else {
                        this.errorMessage = "Problemi nel cambiamento della password"
                        console.log("DEBUG: error changing pwd", res.status, res.statustext)
                    }
                }
            ).catch((error) => {
                console.log("error status", error);
                this.login_error = true  
                this.errorMessage = "errore di connessione al server - riprovare. Se il problema persiste contattare l'amministratore"
            });
        },
        close(){
            this.$router.back();
        }
    },
}
</script>

<style>

</style>
